import { memo } from "react";

const SIDEBAR_KEYS = ["s1", "s2", "s3", "s4", "s5", "s6"];
const UP_NEXT_KEYS = ["u1", "u2", "u3", "u4"];

const UpNextCardSkeleton = () => (
  <div className="col-6 col-md-3 my-2">
    <span
      className="placeholder d-block w-100"
      style={{ aspectRatio: "16 / 9", borderRadius: 10 }}
      aria-hidden="true"
    />
    <span
      className="placeholder d-block col-10 mt-2"
      style={{ height: 12, borderRadius: 4 }}
      aria-hidden="true"
    />
    <span
      className="placeholder d-block col-7 mt-1"
      style={{ height: 12, borderRadius: 4 }}
      aria-hidden="true"
    />
  </div>
);

/**
 * Loading skeleton for the Course Detail screen — mirrors the real layout
 * (banner, lesson sidebar, video player and the "Up Next" row) so there is no
 * layout shift once data arrives. Uses Bootstrap's `placeholder` utilities.
 */
const CourseDetailSkeleton = () => (
  <div className="placeholder-glow" role="status" aria-label="Loading">
    {/* Banner */}
    <div className="w-100 courses_bg d-flex flex-column justify-content-center">
      <div className="container-xxl px-lg-5 text-white">
        <span
          className="placeholder col-4 d-block mb-2"
          style={{ height: 32, borderRadius: 6 }}
          aria-hidden="true"
        />
        <span
          className="placeholder col-6 d-block"
          style={{ height: 16, borderRadius: 4 }}
          aria-hidden="true"
        />
      </div>
    </div>

    <div className="w-100 my-4 course_details">
      <div className="container-xxl">
        <div className="row gx-0 gx-lg-5">
          {/* Lesson sidebar (desktop) */}
          <div className="col-12 col-md-4 d-none d-lg-block order-lg-2">
            <div className="w-100 courses-bg p-3 mt-4 br-10px">
              {SIDEBAR_KEYS.map((key, index) => (
                <span
                  key={key}
                  className="placeholder d-block mb-3"
                  style={{
                    width: `${85 - index * 7}%`,
                    height: 16,
                    borderRadius: 4,
                  }}
                  aria-hidden="true"
                />
              ))}
            </div>
          </div>

          {/* Video player + "Up Next" */}
          <div className="col-12 col-md-12 col-lg-8">
            <div className="w-100 p-3 my-4 courses-bg br-10px">
              <span
                className="placeholder d-block w-100"
                style={{ height: 476, borderRadius: 10 }}
                aria-hidden="true"
              />
              <span
                className="placeholder col-5 d-block mt-3"
                style={{ height: 20, borderRadius: 4 }}
                aria-hidden="true"
              />
            </div>

            <h5 className="fw-bold">Up Next</h5>
            <div className="row">
              {UP_NEXT_KEYS.map((key) => (
                <UpNextCardSkeleton key={key} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
    <span className="visually-hidden">Loading…</span>
  </div>
);

export default memo(CourseDetailSkeleton);
